export default __webpack_public_path__ + "static/media/checkbox-checked.b1544bf0.svg";